exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.details .icon[data-v-1ab44934] {\n  font-size: 30px;\n}\n.details .count[data-v-1ab44934] {\n  font-size: 20px;\n  vertical-align: bottom;\n}\n.fav-star-icon[data-v-1ab44934] {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n}\n.fav-star-icon span svg[data-v-1ab44934] {\n  height: 1.5em;\n  width: 1.5em;\n  pointer-events: none;\n}\n", ""]);

// exports
